import React, {useCallback, useEffect, useState} from 'react';
import Wrapper from "../components/Wrapper.js";
import OrganizationItem from "../components/OrganizationItem.js";
import {useLocation, useNavigate} from "react-router-dom";
import qs from "query-string";
import {useDispatch, useSelector} from "react-redux";
import Account from "../helpers/Account.js";
import CheckboxFilter from "../components/CheckboxFilter.js";
import Select from "react-select";
import makeAnimated from 'react-select/animated';
import {ClipLoader} from "react-spinners";
import Api from "../Api.js";
import SearchBar from "../components/SearchBar.js";
import ReactPaginate from "react-paginate";
import CustomPagination from "../components/BlueButton/CustomPagination.js";


const {profession, id} = Account.getData()

function Organizations(props) {
    const employee = useSelector((state) => state.manager.employee);
    const location = useLocation()
    const navigate = useNavigate()
    const query = qs.parse(location.search, {arrayFormat: 'comma'});
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(true);
    const [service, setService] = useState([]);
    const [organization, setOrganization] = useState([]);
    const [repeat, setRepeat] = useState(false);
    const [current, setCurrent] = useState(0);

    useEffect(() => {
        (async () => {
            await fetchCompanyService();
            const stringify = qs.stringify(query, {addQueryPrefix: true, encode: false}); // Convert back to string
            await fetchOrganizations(stringify)
            setCurrent(query?.offset? Math.ceil(query?.offset/9):0)
            if (profession === 'accountant') {
                if (id) {
                    await updateFilter({accountant: id,name:query?.name||'',offset:query?.offset || ''});
                } else {
                    setRepeat(true);
                }
            }
        })()
    }, [location.search]);

    const fetchCompanyService = async () => {
        try {
            const {data} = await Api.companyServices()
            setService(data.results)
        } catch (e) {
            console.log(e)
        }
    };

    const updateFilter =  useCallback(async (newFilter) => {
        const updatedFilter = { ...query, ...newFilter };
        if (!updatedFilter.is_deleted) delete updatedFilter.is_deleted;
        const serviceValue = updatedFilter.service || '';
        const stringServiceValue = String(serviceValue).trim();
        if (!Boolean(+stringServiceValue)) delete updatedFilter.service;
        const stringify = qs.stringify(updatedFilter, { addQueryPrefix: true, encode: false }); // Convert back to string
        navigate(`?${stringify}`, { replace: true });

    },[location.search])

    const fetchOrganizations = async (filterParams) => {
        try {
            setLoading(true)
            const {data} = await Api.companyManager(filterParams)
            setOrganization(data)
            setCurrent(1)
            setLoading(false)

        } catch (e) {
            console.log(e)
            setLoading(false)

        }
    };

    const handlePageChange = async (pageNumber) => {
        const offset = pageNumber === 0 ? '' : (pageNumber-1) * 9;
        setCurrent(pageNumber)
        await updateFilter({offset});
    };

    const getServiceOptions = () => {
        const options = service.map((item) => ({label: item.name, value: item.id}));
        return [...options, {label: 'Ընտրել բոլորը', value: ''}];
    };

    const renderOrganizations = () => {
        if (loading) {
            return <ClipLoader type="Oval" color="#101C2A" size={30}/>;
        }
        if(!loading && !organization?.results?.length){
            return <div className="no_tasks text-center">Կազմակերպություն չկա</div>
        }
        return organization?.results?.filter(item => !item.is_deleted_by_manager).map((item, index) => (
            <div key={index} className="company-card">
                <OrganizationItem
                    id={item.id}
                    is_deleted={item.is_deleted}
                    orgname={item.name}
                    name={item.client.user.first_name}
                    surname={item.client.user.last_name}
                    HVHH={item.HVHH}
                    phone={item.client.phone}
                    logo={item.logo}
                    accountant_list={item.accountant || []}
                />
            </div>
        ));
    };

    return (
        <Wrapper>
            <div className='organizations'>
                {show && <div className='popup' onClick={() => setShow(false)}/>}
                {/*{show && <AddEmployeeOrg create={word.add_new_org} />}*/}
                {profession === 'accountant' && <div className="page-heading">Ինձ կցված կազմակերպությունները</div>}
                <SearchBar value={query.name || ''} onChange={(value) => updateFilter({ name: value, offset: '' })} />
                <Select
                    closeMenuOnSelect={true}
                    // components={makeAnimated()}
                    options={getServiceOptions()}
                    onChange={(data) => updateFilter({service: data.value, offset: ''})}
                    placeholder="Ծառայություն"
                />
                <CheckboxFilter
                    title="Օգտատիրոջ կողմից ջնջված կազմակերպությունները"
                    my_task={Boolean(query.is_deleted)}
                    onChange={async () => await updateFilter({is_deleted: !Boolean(query.is_deleted), offset: ''})}
                />
                <div className='organizations-list'>
                    {repeat ? (
                        <span className="repeat-text" onClick={async () => {
                            await updateFilter({accountant: employee.id});
                            Account.setData(employee)
                            setRepeat(false);
                        }}>Խնդրոմ ենք նորից կրկնել</span>
                    ) : renderOrganizations()}
                </div>
                {organization?.count > 9 && (

                    <div className="d-flex justify-content-center">
                    <CustomPagination
                    currentPage={+query.offset? query.offset/9 + 1  : 1}
                    totalItems={organization?.count}
                    itemsPerPage={9}
                    totalPages={Math.ceil(organization?.count / 9) || 0}
                    onPageChange={(newPage) => handlePageChange(newPage)}
                    />
                    </div>
                )}
            </div>

        </Wrapper>
    );
}

export default Organizations;
